function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_20",
  "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 20",
  transform: "translate(0 12.586)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_19",
  "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 19"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 7",
  d: "M23.328,257.323a12.014,12.014,0,0,0-12,12,.522.522,0,1,0,1.044,0,10.956,10.956,0,0,1,21.913,0,.522.522,0,1,0,1.044,0A12.013,12.013,0,0,0,23.328,257.323Z",
  transform: "translate(-11.328 -257.323)",
  fill: "#313136"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_22",
  "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 22",
  transform: "translate(6.261)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_21",
  "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 21"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 8",
  d: "M145.067,0a5.739,5.739,0,1,0,5.739,5.739A5.746,5.746,0,0,0,145.067,0Zm0,10.435a4.7,4.7,0,1,1,4.7-4.7A4.7,4.7,0,0,1,145.067,10.435Z",
  transform: "translate(-139.328)",
  fill: "#313136"
})));

var SvgPerson20 = function SvgPerson20(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    width: 24,
    height: 25.108,
    viewBox: "0 0 24 25.108",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerson20, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person-20.55a27b25.svg";
export { ForwardRef as ReactComponent };